import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ngVar]',
})
export class VarDirective {
    private vcRef = inject(ViewContainerRef);
    private templateRef = inject<TemplateRef<any>>(TemplateRef);

    @Input()
    set ngVar(context: any) {
        this.context.$implicit = this.context.ngVar = context;
        this.updateView();
    }

    context: any = {};

    updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
